/**
 PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA

 *  Copyright © 2017 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

import Configuration from '../../config';

export default class EventManager {
  constructor(contextData) {
    this.contextData = Object.assign({}, contextData);
  }

  setProductId(productId) {
    this.contextData.productId = productId;
  }

  dispatch(event) {
    const appName = this.contextData.product ? `- ${this.contextData.product}` : '';
    this.contextData.onEvent(event);

    if (!this.contextData.disableAnalytics) {
      const newEvent = Object.assign({}, event);

      newEvent.label = Object.prototype.hasOwnProperty.call(event, 'data') ? JSON.stringify(event.data) : event.label;
      delete newEvent.data;
      newEvent.category = `${newEvent.category} ${appName}`;
      newEvent.productId = this.contextData.productId;
      newEvent.appVersion = this.contextData.appVersion;
      /**
       * Condition for mojo/etext to override productId as book id
       * TODO: Need to address this from all components later
       */
      if (event.book_id && window.localStorage && window.localStorage.getItem(`bookId_${event.book_id}`)) {
        newEvent.book_id = window.localStorage.getItem(`bookId_${event.book_id}`);
      }

      // datalayer push for GTM
      newEvent.event = newEvent.event || newEvent.name || Configuration.MMI_FiringEvent;

      if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push(newEvent);
        // Passing events to Appcues for analytics
        if (window.passEventToAppcues) {
          window.passEventToAppcues(newEvent);
        }
      }
      if (window.top && window.top !== window.self) {
        window.top.postMessage(newEvent, '*');
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/EventManager.jsx